interface AllTopicsProps {
  data: any;
}

import Link from "next/link";

const AllTopics = ({ data }: AllTopicsProps) => {
  return (
    <div className="flex flex-wrap items-center mb-4 sm:gapy-0 gap-y-2">
      <p className="m-0 mr-2 font-medium dark:text-dark-text-primary">
        Topics :
      </p>
      {data.map((eachTopics: any, eachInd: number) => (
        <Link
          href={`/blog/categories/${eachTopics._id}`}
          key={eachInd + 1 + ""}
        >
          <div className="p-1 px-4 mr-2 text-xs border border-gray-500 rounded-full dark:text-dark-text-primary">
            {eachTopics.title} ({eachTopics.blog_counts})
          </div>
        </Link>
      ))}
    </div>
  );
};
export default AllTopics;
